import React, { useState, useEffect } from "react";
import "../../css/components/reusable/RightSideDrawer.css";

const RightSideDrawer = ({
    isOpen,
    onClose,
    title,
    width = "500px",
    children,
}) => {
    const [mounted, setMounted] = useState(isOpen);
    useEffect(() => {
        if (isOpen) {
            setMounted(true);
            return;
        }
        const timer = setTimeout(() => { setMounted(false); }, 380);

        return () => clearTimeout(timer);
    }, [isOpen]);

    if (!mounted) { return null; }

    return (
        <div
            className={`right-side-drawer-overlay ${isOpen ? "open" : ""}`}
            onClick={onClose}
        >
            <div
                className={`right-side-drawer ${isOpen ? "open" : ""}`}
                style={{ width }}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="right-side-drawer-header">
                    <h2>{title}</h2>

                    <button
                        className="right-side-drawer-close"
                        onClick={onClose}
                    >
                        ✕
                    </button>
                </div>

                <div className="right-side-drawer-body">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default RightSideDrawer;
